import { render, staticRenderFns } from "./AddAllocation.vue?vue&type=template&id=45ca4baf&scoped=true&"
import script from "./AddAllocation.vue?vue&type=script&lang=js&"
export * from "./AddAllocation.vue?vue&type=script&lang=js&"
import style0 from "./AddAllocation.vue?vue&type=style&index=0&id=45ca4baf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ca4baf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ca4baf')) {
      api.createRecord('45ca4baf', component.options)
    } else {
      api.reload('45ca4baf', component.options)
    }
    module.hot.accept("./AddAllocation.vue?vue&type=template&id=45ca4baf&scoped=true&", function () {
      api.rerender('45ca4baf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/Allocations/AddAllocation/AddAllocation.vue"
export default component.exports